// Delegated preview works after native facet rendering and infinite scrolling.
let preview;
let owner;
const hide = () => { preview?.remove(); preview = null; owner = null; };
function show(link) {
  if (!link?.dataset.preview || !link.closest('[product-grid-view="list"]')) return;
  hide();
  owner = link;
  preview = document.createElement('div');
  preview.className = 'jw-order-preview';
  preview.setAttribute('aria-hidden', 'true');
  const img = new Image();
  img.alt = '';
  img.src = link.dataset.preview;
  preview.append(img);
  document.body.append(preview);
  const rect = link.getBoundingClientRect();
  preview.style.left = `${Math.max(8, Math.min(rect.right + 12, innerWidth - 276))}px`;
  preview.style.top = `${Math.max(8, Math.min(rect.top - 80, innerHeight - 276))}px`;
}
document.addEventListener('pointerover', e => {
  if (!matchMedia('(hover:hover)').matches) return;
  const link = e.target.closest('.jw-order-thumb');
  if (link && link !== owner) show(link);
});
document.addEventListener('pointerout', e => {
  if (owner && owner.contains(e.target) && !owner.contains(e.relatedTarget)) hide();
});
document.addEventListener('focusin', e => { if (e.target.matches('.jw-order-thumb')) show(e.target); });
document.addEventListener('focusout', e => { if (e.target === owner) hide(); });
document.addEventListener('keydown', e => { if (e.key === 'Escape') hide(); });
window.addEventListener('scroll', hide, true);
window.addEventListener('resize', hide);
new MutationObserver(() => { if (owner && (!owner.isConnected || !owner.closest('[product-grid-view="list"]'))) hide(); }).observe(document.documentElement, {childList:true,subtree:true,attributes:true,attributeFilter:['product-grid-view']});
